import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { Spinner } from 'react-bootstrap';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, authChecked } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (!authChecked) {
   
    return (
      <div className="text-center p-5">
        <Spinner animation="border" size="lg" className="me-2" />
        <h4>Checking authentication...</h4>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Render children if authenticated
  return children;
};

export default ProtectedRoute;
